import { api } from "./client";

export const usersApi = {
  list: () => api.get("/users").then((r) => r.data.users),
  get: (id) => api.get(`/users/${id}`).then((r) => r.data.user),
  create: (data) => api.post("/users", data).then((r) => r.data.user),
  update: (id, data) => api.patch(`/users/${id}`, data).then((r) => r.data.user),
  remove: (id) => api.delete(`/users/${id}`).then((r) => r.data),
};
